import {
    UNP_CTA_BUTTON, UNP_CTA_SUBTITLE, UNP_CTA_TITLE,
    UNP_DISCLAIMER_BODY, UNP_DISCLAIMER_EYEBROW, UNP_DISCLAIMER_TITLE,
    UNP_FAQ_A1, UNP_FAQ_A2, UNP_FAQ_A3, UNP_FAQ_A4, UNP_FAQ_A5,
    UNP_FAQ_EYEBROW, UNP_FAQ_Q1, UNP_FAQ_Q2, UNP_FAQ_Q3, UNP_FAQ_Q4, UNP_FAQ_Q5,
    UNP_FAQ_SUBTITLE, UNP_FAQ_TITLE,
    UNP_HELMET_DESCRIPTION, UNP_HELMET_TITLE,
    UNP_HERO_CTA_BOOK, UNP_HERO_CTA_CALL, UNP_HERO_EYEBROW, UNP_HERO_SUBTITLE,
    UNP_HERO_TITLE, UNP_HERO_TITLE_ACCENT,
    UNP_HERO_TRUST_BILINGUAL, UNP_HERO_TRUST_DOCS, UNP_HERO_TRUST_FAST,
    UNP_PROCESS_EYEBROW,
    UNP_PROCESS_STEP1_DESC, UNP_PROCESS_STEP1_TITLE,
    UNP_PROCESS_STEP2_DESC, UNP_PROCESS_STEP2_TITLE,
    UNP_PROCESS_STEP3_DESC, UNP_PROCESS_STEP3_TITLE,
    UNP_PROCESS_STEP4_DESC, UNP_PROCESS_STEP4_TITLE,
    UNP_PROCESS_TITLE,
    UNP_SERVICES_EYEBROW, UNP_SERVICES_SUBTITLE, UNP_SERVICES_TITLE,
    UNP_SERVICE_APPEAL_DESC, UNP_SERVICE_APPEAL_TITLE,
    UNP_SERVICE_DOCS_DESC, UNP_SERVICE_DOCS_TITLE,
    UNP_SERVICE_FILE_DESC, UNP_SERVICE_FILE_TITLE,
    UNP_SERVICE_FOLLOWUP_DESC, UNP_SERVICE_FOLLOWUP_TITLE,
    UNP_SERVICE_TRANSLATE_DESC, UNP_SERVICE_TRANSLATE_TITLE,
    UNP_SERVICE_WEEKLY_DESC, UNP_SERVICE_WEEKLY_TITLE,
} from "../types";

const en_unemployment_page = {
    helmet: {
        [UNP_HELMET_TITLE]: "Unemployment claim help in English & Spanish | Linares Pro Corp",
        [UNP_HELMET_DESCRIPTION]: "Help filing your unemployment claim, weekly certifications, appeals, and supporting documents — explained step by step in your language.",
    },
    section: {
        hero: {
            [UNP_HERO_EYEBROW]: "Unemployment assistance",
            [UNP_HERO_TITLE]: "Lost your job?",
            [UNP_HERO_TITLE_ACCENT]: "We help you file the right way.",
            [UNP_HERO_SUBTITLE]: "We walk you through your unemployment claim in English or Spanish — initial filing, weekly certifications, and what to do if you receive a denial.",
            [UNP_HERO_CTA_BOOK]: "Get help filing",
            [UNP_HERO_CTA_CALL]: "Call now",
            [UNP_HERO_TRUST_BILINGUAL]: "English & Spanish",
            [UNP_HERO_TRUST_DOCS]: "Documents reviewed",
            [UNP_HERO_TRUST_FAST]: "Same-week appointments",
        },
        services: {
            [UNP_SERVICES_EYEBROW]: "How we help",
            [UNP_SERVICES_TITLE]: "From your first claim to your last payment.",
            [UNP_SERVICES_SUBTITLE]: "We stay with you through the whole process so you don't lose a benefit because of a missed form.",
            [UNP_SERVICE_FILE_TITLE]: "File your initial claim",
            [UNP_SERVICE_FILE_DESC]: "We help you complete and submit your initial unemployment application with the right information.",
            [UNP_SERVICE_APPEAL_TITLE]: "Appeals & denials",
            [UNP_SERVICE_APPEAL_DESC]: "If your claim is denied, we help you organize the documents and prepare your appeal on time.",
            [UNP_SERVICE_WEEKLY_TITLE]: "Weekly certifications",
            [UNP_SERVICE_WEEKLY_DESC]: "We help you keep up with the weekly questions so your payments don't get interrupted.",
            [UNP_SERVICE_DOCS_TITLE]: "Document preparation",
            [UNP_SERVICE_DOCS_DESC]: "Termination letters, pay stubs, IDs — we make sure your packet is complete before you submit.",
            [UNP_SERVICE_TRANSLATE_TITLE]: "Translation support",
            [UNP_SERVICE_TRANSLATE_DESC]: "We translate notices and explain in Spanish exactly what the system is asking from you.",
            [UNP_SERVICE_FOLLOWUP_TITLE]: "Ongoing follow-up",
            [UNP_SERVICE_FOLLOWUP_DESC]: "We help you respond to requests and stay on top of your claim until it's resolved.",
        },
        process: {
            [UNP_PROCESS_EYEBROW]: "How it works",
            [UNP_PROCESS_TITLE]: "A clear path through a confusing system.",
            [UNP_PROCESS_STEP1_TITLE]: "Free consultation",
            [UNP_PROCESS_STEP1_DESC]: "Tell us your work history and what happened. We confirm what you can apply for.",
            [UNP_PROCESS_STEP2_TITLE]: "Document review",
            [UNP_PROCESS_STEP2_DESC]: "We list the documents you need and review what you bring before sending anything.",
            [UNP_PROCESS_STEP3_TITLE]: "File the claim",
            [UNP_PROCESS_STEP3_DESC]: "We complete the application with you and submit it correctly the first time.",
            [UNP_PROCESS_STEP4_TITLE]: "Weekly support",
            [UNP_PROCESS_STEP4_DESC]: "We help you with weekly certifications, notices, and any appeal if it's needed.",
        },
        disclaimer: {
            [UNP_DISCLAIMER_EYEBROW]: "Honest note",
            [UNP_DISCLAIMER_TITLE]: "We are not lawyers, and we don't decide your claim.",
            [UNP_DISCLAIMER_BODY]: "We are a bilingual notary and document-assistance office. The state agency decides whether to approve your unemployment claim. What we do is make sure your application is complete, correct, and submitted on time so nothing is missed.",
        },
        faq: {
            [UNP_FAQ_EYEBROW]: "Unemployment FAQ",
            [UNP_FAQ_TITLE]: "Common questions about unemployment.",
            [UNP_FAQ_SUBTITLE]: "We answer the questions we hear every week. Anything else, just call.",
            [UNP_FAQ_Q1]: "Do you guarantee that my claim will be approved?",
            [UNP_FAQ_A1]: "No one can guarantee that — only the state agency approves claims. We make sure your application is complete and submitted on time so it has the best chance.",
            [UNP_FAQ_Q2]: "What if I don't speak English?",
            [UNP_FAQ_A2]: "That's exactly why we exist. We explain everything in Spanish and translate any notice you receive.",
            [UNP_FAQ_Q3]: "I was denied. Can you still help?",
            [UNP_FAQ_A3]: "Yes. We help you organize the documents and prepare your appeal within the deadline.",
            [UNP_FAQ_Q4]: "How long does it take to receive payments?",
            [UNP_FAQ_A4]: "Times vary by state. Once your claim is approved and weekly certifications are filed, payments usually arrive on a regular schedule.",
            [UNP_FAQ_Q5]: "Do I have to keep looking for work?",
            [UNP_FAQ_A5]: "Most states require you to register for work and report your search. We explain exactly what your state requires.",
        },
        cta: {
            [UNP_CTA_TITLE]: "Don't file alone.",
            [UNP_CTA_SUBTITLE]: "Bring your paperwork and we'll walk through it together.",
            [UNP_CTA_BUTTON]: "Call now",
        },
    },
};

export default en_unemployment_page;
